export default {
  EXPIRED: "expired",
  ACTIVE: "active",
  INACTIVE_PENDING: "inactivePending",
  INACTIVE_CONFIRMED: "inactiveConfirmed",
};
